import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/router/index";
import PerfectScrollbar from "vue3-perfect-scrollbar";
import CookieTooltipPopup from "@/popups/CookieTooltipPopup.vue";
import { initYandexMetrika } from "@/api/yandexMetrika";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";

initYandexMetrika();

createApp(App)
  .use(router)
  .use(PerfectScrollbar)
  .component("CookieTooltipPopup", CookieTooltipPopup)
  .mount("#app");
